module.exports = __webpack_public_path__ + "media/icons/user-minus-1a679bb3b94ddeb38e9378fbb69e95b9.svg";